module.exports = __webpack_public_path__ + "static/media/mock1.9a57c39a.jpg";